import { createSlice } from "@reduxjs/toolkit";
import { getExceptions } from "./thunks";

import { ExceptionStateType, IException } from "./types";

const initialState: ExceptionStateType = {
  exceptionData: [],
};

export const exception = createSlice({
  name: "exception",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getExceptions.fulfilled, (state, action) => {
      state.exceptionData = action.payload.map((exception: IException, index: number) => ({
        ...exception,
        index
      }));
    });
  },
});
export const {} = exception.actions;
export default exception.reducer;
